const FORM_SELECTOR = '.donation_shortcode form.donation_form';
const BUTTON_SELECTOR = '.donation_form_add_to_cart_button';
const AMOUNT_FIELDS = [
	'input[name="predefined_amount"]',
	'input[name="custom_amount"]',
	'select[name="user_paying_currency"]',
].join( ', ' );
const UPDATE_FIELDS = [
	AMOUNT_FIELDS,
	'input[name="donation_frequency"]',
	'input[name="donation_tribute"]',
].join( ', ' );

const formatNumber = ( value ) => {
	const number = Number( value );

	if ( ! Number.isFinite( number ) || number <= 0 ) {
		return '';
	}

	const decimalPlaces = Math.min(
		2,
		( String( value ).split( '.' )[ 1 ] || '' ).length
	);

	return number.toLocaleString( undefined, {
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces,
	} );
};

const getCurrencySymbol = ( form, amountField ) => {
	const currencyOption = form.querySelector(
		'select[name="user_paying_currency"] option:checked'
	);

	return (
		currencyOption?.dataset.symbol ||
		amountField?.closest( '[data-currencysymbol]' )?.dataset
			.currencysymbol ||
		form.querySelector( '[data-currencysymbol]' )?.dataset.currencysymbol ||
		''
	);
};

const getSelectedAmount = ( form ) => {
	const customAmount = form.querySelector( 'input[name="custom_amount"]' );
	const formattedCustomAmount = formatNumber( customAmount?.value );

	if ( formattedCustomAmount ) {
		return `${ getCurrencySymbol(
			form,
			customAmount
		) }${ formattedCustomAmount }`;
	}

	const selectedAmount = form
		.querySelector( 'input[name="predefined_amount"]:checked' )
		?.closest( '.predefined_amount' );

	if ( ! selectedAmount ) {
		return '';
	}

	const displayedAmount = selectedAmount
		.querySelector( '.amount_value' )
		?.cloneNode( true );

	displayedAmount
		?.querySelectorAll( '.amount_monthly_text' )
		.forEach( ( suffix ) => suffix.remove() );

	return displayedAmount?.textContent.replace( /\s+/g, '' ).trim() || '';
};

const getButtonTextNode = ( button ) => {
	const existingTextNode = Array.from( button.childNodes ).find(
		( node ) =>
			node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== ''
	);

	if ( existingTextNode ) {
		return existingTextNode;
	}

	const textNode = document.createTextNode( '' );
	button.prepend( textNode );

	return textNode;
};

const isMonthlyDonation = ( form ) => {
	const selectedFrequency = form.querySelector(
		'input[name="donation_frequency"]:checked'
	);
	const hiddenFrequency = form.querySelector(
		'input[name="donation_frequency"][type="hidden"]'
	);

	return ( selectedFrequency || hiddenFrequency )?.value === 'monthly';
};

const isTributeDonation = ( form ) =>
	form.closest( '.tribute-donation' ) ||
	form.querySelector( 'input[name="donation_tribute"]:checked' );

const updateButton = ( form ) => {
	const button = form.querySelector( BUTTON_SELECTOR );

	if ( ! button ) {
		return;
	}

	const textNode = getButtonTextNode( button );

	if ( ! button.dataset.fcDefaultLabel ) {
		button.dataset.fcDefaultLabel =
			textNode.nodeValue.trim() || button.textContent.trim();
	}

	const amount = getSelectedAmount( form );
	let label = button.dataset.fcDefaultLabel;
	const isMonthly = isMonthlyDonation( form );

	if ( amount ) {
		if ( isMonthly ) {
			label = `Start my monthly gift of ${ amount }/mo`;
		} else if ( isTributeDonation( form ) ) {
			label = `Send tribute gift of ${ amount }`;
		} else {
			label = `${ button.dataset.fcDefaultLabel } ${ amount }`;
		}
	}

	if ( textNode.nodeValue !== label ) {
		textNode.nodeValue = label;
	}
};

const updateUnlimitedOption = ( form ) => {
	const select = form.querySelector(
		'select[name="donation_frequency_period"]'
	);
	const unlimitedOption = select?.querySelector(
		'option[value="unlimited"]'
	);

	if ( ! unlimitedOption ) {
		return;
	}

	if ( unlimitedOption.textContent !== 'Unlimited (until cancelled)' ) {
		unlimitedOption.textContent = 'Unlimited (until cancelled)';
	}

	if ( select.firstElementChild !== unlimitedOption ) {
		select.prepend( unlimitedOption );
	}
};

const initializeDonationForms = () => {
	document.querySelectorAll( FORM_SELECTOR ).forEach( ( form ) => {
		updateUnlimitedOption( form );
		updateButton( form );
	} );
};

const handleFormUpdate = ( event ) => {
	if ( ! event.target.matches( UPDATE_FIELDS ) ) {
		return;
	}

	const form = event.target.closest( FORM_SELECTOR );

	if ( form ) {
		updateButton( form );
	}
};

const initialize = () => {
	initializeDonationForms();

	document.addEventListener( 'click', handleFormUpdate );
	document.addEventListener( 'input', handleFormUpdate );
	document.addEventListener( 'change', handleFormUpdate );

	const observer = new MutationObserver( ( mutations ) => {
		const forms = new Set();

		mutations.forEach( ( mutation ) => {
			Array.from( mutation.addedNodes ).forEach( ( node ) => {
				if ( node.nodeType !== Node.ELEMENT_NODE ) {
					return;
				}

				const closestForm = node.closest( FORM_SELECTOR );

				if ( closestForm ) {
					forms.add( closestForm );
				}

				node
					.querySelectorAll( FORM_SELECTOR )
					.forEach( ( form ) => forms.add( form ) );
			} );
		} );

		forms.forEach( ( form ) => {
			updateUnlimitedOption( form );
			updateButton( form );
		} );
	} );

	observer.observe( document.body, {
		childList: true,
		subtree: true,
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initialize );
} else {
	initialize();
}
